import { useQuery } from "@tanstack/react-query";
import { QueryModule } from "@/data/queryModules";
import { AppQueryOptions } from "@povio/openapi-codegen-cli";
import { PublicProfileApi } from "./publicProfile.api";

export namespace PublicProfileQueries {

export const moduleName = QueryModule.PublicProfile;

export const keys = {
    all: [moduleName] as const,
    getProfilePublic: (userId: string, ) => [...keys.all, "/public/profile/:userId", userId] as const,
    getJobSkillMatrix: (userId: string, ) => [...keys.all, "/public/profile/:userId/job-skill-matrix", userId] as const,
    getBlsSkillIndustry: (userId: string, ) => [...keys.all, "/public/profile/:userId/bls-skill-industry", userId] as const,
    getEndorsements: (userId: string, ) => [...keys.all, "/public/profile/:userId/endorsements", userId] as const,
    getProfilePicture: (userId: string, ) => [...keys.all, "/public/profile/:userId/profile-picture", userId] as const,
};


 /** 
 * Query `useGetProfilePublic`
 * @param { string } object.userId Path parameter
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<PublicProfileModels.PublicProfileResponseDto> } Public Profile
 * @statusCodes [200]
 */
export const useGetProfilePublic = <TData>({ userId }: { userId: string,  }, options?: AppQueryOptions<typeof PublicProfileApi.getProfilePublic, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getProfilePublic(userId),
    queryFn: () =>  
    
    PublicProfileApi.getProfilePublic(userId)
    ,
    ...options,
  });
};






 /** 
 * Query `useGetJobSkillMatrix`
 * @param { string } object.userId Path parameter
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileJobSkillMatrixResponseDto> } 
 * @statusCodes [200]
 */
export const useGetJobSkillMatrix = <TData>({ userId }: { userId: string,  }, options?: AppQueryOptions<typeof PublicProfileApi.getJobSkillMatrix, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getJobSkillMatrix(userId),
    queryFn: () =>  
    
    PublicProfileApi.getJobSkillMatrix(userId)
    ,
    ...options,
  });
};






 /** 
 * Query `useGetBlsSkillIndustry`
 * @param { string } object.userId Path parameter
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<CommonModels.ProfileBlsSkillIndustryResponseDto> } 
 * @statusCodes [200]
 */
export const useGetBlsSkillIndustry = <TData>({ userId }: { userId: string,  }, options?: AppQueryOptions<typeof PublicProfileApi.getBlsSkillIndustry, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getBlsSkillIndustry(userId),
    queryFn: () =>  
    
    PublicProfileApi.getBlsSkillIndustry(userId)
    ,
    ...options,
  });
};






 /** 
 * Query `useGetEndorsements`
 * @param { string } object.userId Path parameter
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<PublicProfileModels.GetEndorsementsResponse> } 
 * @statusCodes [200]
 */
export const useGetEndorsements = <TData>({ userId }: { userId: string,  }, options?: AppQueryOptions<typeof PublicProfileApi.getEndorsements, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getEndorsements(userId),
    queryFn: () =>  
    
    PublicProfileApi.getEndorsements(userId)
    ,
    ...options,
  });
};






 /** 
 * Query `useGetProfilePicture`
 * @param { string } object.userId Path parameter
 * @param { AppQueryOptions } options Query options
 * @returns { UseQueryResult<PublicProfileModels.PublicProfilePictureDto> } 
 * @statusCodes [200]
 */
export const useGetProfilePicture = <TData>({ userId }: { userId: string,  }, options?: AppQueryOptions<typeof PublicProfileApi.getProfilePicture, TData>) => {
  
  
  return useQuery({
    queryKey: keys.getProfilePicture(userId),
    queryFn: () =>  
    
    PublicProfileApi.getProfilePicture(userId)
    ,
    ...options,
  });
};






}
